import { DatatableRowStyler } from '@app/shared/table/styler/datatable-row-styler';

export class NullRowStyler implements DatatableRowStyler {
  applyRowStyling(_: any): any {
    return {};
  }
}
